export default function calcVh() {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

export function resizeCalcVh() {
  window.addEventListener('resize', calcVh)
}
